export default __webpack_public_path__ + "static/media/folder-green.03f47471.svg";